/**
 * @file Single Project.
 */

import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

/**
 * Single Project functions.
 *
 * Runs js specific to the Single Project template.
 */
const vSingleProject = () => {
	import('../../components/cs-section-media/cs-section-media').then(({ default: vCsSectionMedia }) => { vCsSectionMedia(); });
	import('../../components/cs-audio/audio').then(({ default: vAudio }) => { vAudio(); });
	import('../../components/cs-video-modal/video-modal').then(({ default: vVideoModal }) => { vVideoModal(); });
	import('../../components/cs-stats/stats').then(({ default: vStats }) => { vStats(); });
	import('../../components/cs-parallax-image/cs-parallax-image').then(({ default: vCsParallaxImage }) => { vCsParallaxImage(); });
	import('../../components/cs-parallax-image/cs-parallax-image-fade').then(({ default: vCsParallaxImageFade }) => { vCsParallaxImageFade(); });

	gsap.registerPlugin(ScrollToPlugin);
	let isScrolling    = false;
	const {vLib}       = window || {};
	const body         = document.querySelector('body');
	const videoSizer   = document.querySelector('.video-overlay__sizer rect');
	const videoWrap    = document.querySelector('.video-overlay__wrap');

	/**
	 * Video resize
	 */
	const videoResize = () => {
		if (body.classList.contains('cs-video-open') ) {
			const width           = videoSizer.getBoundingClientRect().width;
			videoWrap.style.width = `${width}px`;
		}
	};

	/**
	 * Video Open
	 */
	const videoOpen = () => {
		const width           = videoSizer.getBoundingClientRect().width;
		videoWrap.style.width = `${width}px`;
	};

	/**
	 * Scroll to section.
	 *
	 * @param direction
	 */
	const scrollToSection = ( direction ) => {
		const sections = document.querySelectorAll( '.a-cs-text-block, .a-cs-parallax-image' );
		if (!sections.length) {
			return;
		}

		if (isScrolling && direction === isScrolling) {
			return;
		}

		const sectionsArray = [...sections];
		if (direction === 'up') {
			sectionsArray.reverse();
		}

		let targetFound = false;
		sectionsArray.forEach((section) => {
			if (targetFound) {
				return;
			}

			if (
				(direction === 'down' && section.getBoundingClientRect().top > 20) ||
				(direction === 'up' && section.getBoundingClientRect().top < -20)
			) {
				targetFound          = true;
				isScrolling = direction;
				gsap.to( window, {
					duration:   1,
					scrollTo:   section,
					ease:       'sine.out',
					onComplete: () => {
						isScrolling = false;
					},
				} );
			}
		} );
	}

	document.addEventListener('keyup', (e) => {
		if (e.code === 'ArrowRight') {
			scrollToSection('down');
		} else if (e.code === 'ArrowLeft') {
			scrollToSection('up');
		}
	} );

	document.addEventListener('vOverlayStateChange', ({detail}) => {
		const {name} = detail;

		if ('cs-video' !== name) {
			return;
		}

		if (vLib.overlayIsOpen) {
			videoOpen();
		}
	})

	window.addEventListener('resize', videoResize);
};

if (document.readyState !== 'loading') {
	vSingleProject();
} else {
	document.addEventListener('DOMContentLoaded', vSingleProject);
}
